export const MONTHS_MAPPING = {
    nufi: {
      'January': 'Ngù\'fī',
      'February': 'Nkùɑ̀nʉ̀ɑ̀',
      'March': 'Mbàkngòfāt',
      'April': 'Sò\'njɑ̀ɑ̀',
      'May': 'Njwēnɑ̌hntà\'',
      'June': 'Mòmòshʉ̄',
      'July': 'Ntūmbhìngòfāt',
      'August': 'Mɑ̄ngà\'nshì',
      'September': 'Kùkū\'',
      'October': 'Ndǔ\'nzɑ̄',
      'November': 'Nkhʉ̀ɑ̀nʉ̀ɑ̀',
      'December': 'Ncátmɑ̄ŋū'
    },
    ghomala: {
      'January': 'Ŋkə̂mmghě',
      'February': 'Sɔ̂gwǐŋ',
      'March': 'Dzə̂tsə́',
      'April': 'Dzə̂biyɛ́',
      'May': 'Sûnè\'',
      'June': 'Dzʉ̂ʼbvʉ̀',
      'July': 'Fə̀fə̀',
      'August': 'Shwâgə̀fə̀',
      'September': 'Ŋkə̂mbiyɛ́',
      'October': 'Dzʉ̂ʼmkǒ',
      'November': 'Fə̂nàm',
      'December': 'Fʉ̂ʼbvʉ̀'
    }
  };